import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

function useWindowUrl() {
  const history = useHistory();
  const [url, setUrl] = useState(history.location.pathname);

  useEffect(() => {
    // setUrl(window.location.href);
    const handleUrlChange = () => {
      setUrl(history.location.pathname);
    };

    // auto trigger when about to leave page
    window.addEventListener("beforeunload", handleUrlChange);

    window.addEventListener("hashchange", handleUrlChange);

    // trigger it manually
    window.addEventListener("urlChange", handleUrlChange);

    return () => {
      window.removeEventListener("urlChange", handleUrlChange);
      window.removeEventListener("beforeunload", handleUrlChange);
      window.removeEventListener("hashchange", handleUrlChange);
    };
    // eslint-disable-next-line
  }, []);

  const updateUrl = () => {
    let evt = new CustomEvent("urlChange");
    window.dispatchEvent(evt);
  };

  return [url, updateUrl, setUrl];
}

export default useWindowUrl;
